export default {"src":"/_next/static/media/mail.b8e70c29.svg","height":12,"width":20,"blurWidth":0,"blurHeight":0};